import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function MaloljetnickoKrivicnoPravoPM() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Maloljetničko krivično pravo" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Maloljetničko krivično pravo</h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Maloljetničko krivično pravo
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 5
              </p>
              <p>
                <strong>Uslov:</strong> nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Cilj izučavanja predmeta Maloljetničko krivično pravo je
                upoznati studente s posebnim položajem malodobnih učinioca
                krivičnih djela koji se velikim dijelom razlikuje od statusa
                punoljetnih učinioca. Studenti će steći uvid u istorijat
                maloljetničke delikvencije kao i moderne trendove i zahtjeve
                međunarodnih dokumenata koji regulišu problematiku maloljetničke
                delikvencije. Studenti će se detaljno upoznati sa materijalnim i
                procesnopravnim odredbama kao i vidovima zaštite djece.
                Slučajevima iz sudske prakse ukazaće se i na probleme u praksi.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Nakon izučavanja ovog predmeta studenti su osposobljeni: da
                objasne pojam maloljetničkog krivičnog prava kao i njegov odnos
                prema drugim granama prava i sudskoj praksi; da umiju i objasne
                temeljne institute maloljetničkog krivičnog prava; da razumiju i
                na primjenjuju propise iz područija maloljetničnog krivičnog
                prava u svakodnevnom radu; da prave razliku između zakonskih
                odredbi koji se tiču maloljetnih izvršioca krivičnih djela i
                onih koji se tiču punoljetnih učinioca krivičnih djela; da
                razumiju i sprovode alternativne mjere koje se mogu izreći prije
                izricanja krivičnih sankcija radi zaštite interesa zdravlja i
                života maloljetnih učinioca; da komentarišu i upoređuju
                zakonodavna rješenja.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                Pojam i karakteristike maloljetničke delinkvencije;
                Maloljetnička delinkvencija u savremenom društvu; Izvori
                maloljetničkog krivičnog prava; Uzroci maloljetničke
                delinkvencije; Karakteristike maloljetničkog krivičnog prava;
                Vrste i oblici maloljetničke delinkvencije; Krivičnopravni
                status maloljetnika; Vaspitne mjere i vaspitni nalozi;
                Kažnjavanje maloljetnika i izricanje mjera bezbijednosti;
                Krivični postupak prema maloljetnicima; Posebnosti krivičnog
                postupka prema maloljetnicima; izvršenje sankcija prema
                maloljetnicima; Uloga vansudskih organa u postupku prema
                maloljetnicima; Krivično pravna zaštita djece i maloljetnika;
                Maloljetnici kao žrtve krivičnih djela; Zatvor za maloljetnike.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Osnovni oblici rada na predmetu su: predavanja i vježbe
                samostalni rad (seminarski rad i interaktivna nastava)
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>3P + 1V</td>
                    <td>
                      Pojam i karakteristike maloletničke delinkvencije;
                      Maloljetnička delinkvencija u savremenom društvu
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>3P + 1V</td>
                    <td>
                      Izvori maloljetničkog krivičnog prava; Uzroci
                      maloljetničke delinkvencije
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>3P + 1V</td>
                    <td>
                      Karakteristike maloljetničkog krivičnog prava; Vrste i
                      oblici maloljetničke delinkvencije
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>3P + 1V</td>
                    <td>Krivičnopravni status maloljetnika</td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>3P + 1V</td>
                    <td>Vaspitne mjere i vaspitni nalozi</td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>3P + 1V</td>
                    <td>Kolokvijum I</td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>3P + 1V</td>
                    <td>
                      Kažnjavanje maloljetnika i izricanje mjera bezbijednosti
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>3P + 1V</td>
                    <td>Krivični postupak prema maloletnicima</td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>3P + 1V</td>
                    <td>
                      Posebnosti krivičnog postupka prema maloljetnicima;
                      izvršenje sankcija prema maloljetnicima
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>3P + 1V</td>
                    <td>
                      Uloga vansudskih organa u postupku prema maloljetnicima
                    </td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>3P + 1V</td>
                    <td>Kolokvijum II</td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>3P + 1V</td>
                    <td>Krivično pravna zaštita djece i maloljetnika</td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>3P + 1V</td>
                    <td>Maloljetnici kao žrtve krivičnih djela</td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>3P + 1V</td>
                    <td>Krivično pravna zaštita djece i maloljetnika</td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>3P + 1V</td>
                    <td>Zatvor za maloljetnike</td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td>Sveobuhvatni ispit</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td>Ovjera semestra i upis ocjena</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td>Popravni ispitni rok</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 4č / 3h</td>
                            <td>Ukupno: 80h</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 3č / 2.15h</td>
                            <td>Nastava + završni ispit: 60h</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 1č / 0.45h</td>
                            <td>Priprema i ovjera semestra: 6h</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 14h</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default MaloljetnickoKrivicnoPravoPM;
